/**
 * 효과음 매니페스트.
 *
 * 사운드 파일을 import해 한 곳에 모은다(Vite가 해시 URL로 번들링·캐싱). 상위 키는 스토어의
 * 사운드 토글 단위(SOUND_KEYS)와 일치시킨다 — useSound(moduleName)가 이 그룹을 참조한다.
 */
import click from '@/assets/sound/click.mp3';
import complete from '@/assets/sound/complete.mp3';
import typingDefault from '@/assets/sound/typing_default.mp3';
// 공격할때
import attack_1 from '@/assets/sound/attack_1.mp3';
import attack_2 from '@/assets/sound/attack_2.mp3';
import attack_3 from '@/assets/sound/attack_3.mp3';
// 맞을때
import hit from '@/assets/sound/hit.mp3';
// 게임오버
import gameover from '@/assets/sound/gameover.mp3';
// BGM
import videoGame from '@/assets/sound/bgm/video_game.mp3';
import arcadeShort from '@/assets/sound/bgm/arcade_short.mp3';
import ninetyGame from '@/assets/sound/bgm/90s_game.mp3';
import arcade from '@/assets/sound/bgm/arcade.wav';
import ending from '@/assets/sound/bgm/ending.wav';
import journey from '@/assets/sound/bgm/journey.mp3';
import onward from '@/assets/sound/bgm/onward.wav';
import roll from '@/assets/sound/bgm/roll.mp3';
import scrap from '@/assets/sound/bgm/scrap.mp3';
import think from '@/assets/sound/bgm/think.mp3';
import winter from '@/assets/sound/bgm/winter.wav';
import bossWorthyStruggle from '@/assets/sound/bgm/boss/b__worthy_struggle.wav';
import bossHideout from '@/assets/sound/bgm/boss/b_hideout.mp3';
import bossGameOn from '@/assets/sound/bgm/boss/b_game_on.wav';
import bossSpooky from '@/assets/sound/bgm/boss/b_spooky.mp3';
import bossGrind from '@/assets/sound/bgm/boss/b_grind.wav';
import bossGo from '@/assets/sound/bgm/boss/b_go.wav';

export const SOUND_SRC = {
    typing: {
        click,
        complete,
        typingDefault,
        hit,
        attack_1,
        attack_2,
        attack_3,
        gameover,
    },
} as const;

/**
 * BGM 트랙 레지스트리. 교체 기능은 여기 트랙을 추가하고 이름으로 참조한다.
 * (BGM은 SFX와 달리 단일 인스턴스로 루프 재생되므로 별도 그룹으로 분리)
 */
export const BGM_SRC = {
    typing: {
        videoGame,
        arcadeShort,
        ninetyGame,
        arcade,
        ending,
        journey,
        onward,
        roll,
        scrap,
        think,
        winter,
    },
} as const;

export const BGM_BOSS_SRC = {
    typing: {
        bossWorthyStruggle,
        bossHideout,
        bossGameOn,
        bossSpooky,
        bossGrind,
        bossGo,
    },
} as const;

export type SoundModule = keyof typeof SOUND_SRC;
export type SoundName<M extends SoundModule> = keyof (typeof SOUND_SRC)[M];
export type BgmModule = keyof typeof BGM_SRC;
export type BgmScene = 'intro' | 'inplay';
export type BgmName<M extends BgmModule = BgmModule> = keyof (typeof BGM_SRC)[M];
export type BgmBossName<M extends BgmModule = BgmModule> = keyof (typeof BGM_BOSS_SRC)[M];
